"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getEnv_1 = require("./getEnv");
exports.getProfileApiHost = function () {
    switch (getEnv_1.getEnv()) {
        case 'pre':
            return 'https://profileservice-pre-northeurope.cloudapp.net/';
        case 'qa':
            return 'https://profile.skype.net/';
        default:
            return 'https://edge.skype.com/';
    }
};
//# sourceMappingURL=getProfileApiHost.js.map